import { handleActions } from "redux-actions";
import reducerMap from "./reducerMap";
import defaultState from "./defaultState";

export default handleActions(reducerMap, defaultState);
